import { hot } from "react-hot-loader";
import React from "react";
import AppContainer from "editor/containers/AppContainer";
import { Provider } from "react-redux";

const App = ({ store }) => {
  return (
    <Provider store={store}>
      <AppContainer />
    </Provider>
  );
};

export default hot(module)(App);
